import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import NumberUtils from '../../utils/NumberUtils';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

class PotDetailMessages extends Component {
  conditionCheck(
    cYear,
    nYear,
    cMonth,
    nMonth,
    trgAmount,
    monthlyContribution,
    timeRequired,
    expMonth,
    expYear,
    expContribution,
    differentiator,
    expectedTimeSpan
  ) {
    const { content, goal } = this.props;
    if (goal) {
      const goalValue = NumberUtils.appendCurrency('{}', this.props.goal);
      const mc = Number(monthlyContribution);
      const ec = Number(expContribution);
      const mcCurrency = NumberUtils.appendCurrency('{}', mc);
      const ecCurrency = NumberUtils.appendCurrency('{}', ec);
      const nDate = (
        <span>
          {monthNames[nMonth]} {nYear}
        </span>
      );
      const exDate = (
        <span>
          {monthNames[expMonth]} {expYear}
        </span>
      );
      if (expYear <= cYear && trgAmount > 0 && expMonth < cMonth) {
        return (
          <div>
            <div>
              <h5>{content.potMessage9Part1}</h5>
              <p>
                {content.potMessage9Part2} <strong>{goalValue}</strong>{' '}
                {content.potMessage9Part3} {exDate}.{content.potMessage9Part4}
                <br />
                {content.potMessage9Part5}
              </p>
            </div>
          </div>
        );
      } else {
        if (trgAmount <= 0 && this.props.goal > 0) {
          return (
            <div>
              <div>
                <h5>{content.potMessageHead1}</h5>
                <p>
                  {content.potMessage1Part} <strong>{goalValue}</strong>!
                </p>
              </div>
            </div>
          );
        } else {
          if (timeRequired >= 1200 || mc === 0) {
            return (
              <div>
                <div>
                  <h5>{content.potMessageHead2}</h5>
                  <p>
                    {content.potMessage2Part1} <strong>{mcCurrency}</strong>{' '}
                    {content.potMessage2Part2} <strong>{goalValue}</strong>,
                    {content.potMessage2Part3} <br /> {content.potMessage2Part4}
                  </p>
                </div>
              </div>
            );
          } else {
            if (mc === ec) {
              let changedGoal;
              changedGoal = goalValue.replace(/[^\d.]*/g, '');
              if (changedGoal === '') {
                changedGoal = 0;
              }
              const changedContributionAmount =
                Number(changedGoal) / expectedTimeSpan;
              const changedTimeRequired =
                Number(changedGoal) / Number(changedContributionAmount);
              changedGoal = mc * changedTimeRequired + this.props.balance;
              let finalChangedGoal = NumberUtils.appendCurrency(
                '{}',
                parseFloat(changedGoal)
              );
              return (
                <div>
                  <div>
                    <h5>{content.potMessageHead3}</h5>
                    <p>
                      {content.potMessage3Part1} <strong>{mcCurrency}</strong>{' '}
                      {content.potMessage3Part5} {exDate}{' '}
                      {content.potMessage3Part3}{' '}
                      <strong>{finalChangedGoal}</strong>.
                      <br />
                      {content.potMessage3Part4}
                    </p>
                  </div>
                </div>
              );
            } else if (mc < ec) {
              return (
                <div>
                  <div>
                    <h5>{content.potMessageHead4}</h5>
                    <p>
                      {' '}
                      {content.potMessage2Part1} <strong>{mcCurrency}</strong>{' '}
                      {content.potDetailMessage4Part2}{' '}
                      <strong>{goalValue}</strong>{' '}
                      {content.potDetailMessage4Part3} {nDate}.
                      <br />
                      {content.potMessage4Part4} {exDate}{' '}
                      {content.potMessage4Part5} <strong>{ecCurrency}</strong>.
                    </p>
                  </div>
                </div>
              );
            } else {
              if (differentiator === 'ON_TARGET_BUT_OVER') {
                const newAmount =
                  Number(monthlyContribution) * Math.ceil(timeRequired) +
                  this.props.balance;
                const newAmountCurrency = NumberUtils.appendCurrency(
                  '{}',
                  newAmount
                );
                return (
                  <div>
                    <div>
                      <h5>{content.potMessageHead5}</h5>
                      <p>
                        {content.potMessage2Part1}{' '}
                        {content.potDetailMessage5Part2}{' '}
                        <strong>{mcCurrency}</strong>{' '}
                        {content.potDetailMessage5Part3}{' '}
                        <strong>{newAmountCurrency}</strong>{' '}
                        {content.potDetailMessage5Part4} {nDate}.<br />
                        {content.potDetailMessage5Part5}{' '}
                        <strong>{ecCurrency}</strong>{' '}
                        {content.potDetailMessage5Part6}
                      </p>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div>
                    <div>
                      <h5>{content.potMessageHead6}</h5>{' '}
                      <p>{content.potMessage6Part1}</p>
                    </div>
                  </div>
                );
              }
            }
          }
        }
      }
    } else {
      return (
        <div>
          <div>
            <h5>{content.potMessageHead7}</h5> <p>{content.potMessage7Part1}</p>
          </div>
        </div>
      );
    }
  }

  contentHolder() {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();
    let totalTimeRequired = 0;

    let expectedTimeSpan;
    let differentiator = 'SMASH_IT';

    const contributionAmount = Math.abs(
      typeof this.props.amountvalue != 'number' ? 0 : this.props.amountvalue
    ).toFixed(2);

    const newTargetAmount = this.props.goal - this.props.balance;

    if (contributionAmount === 0) {
      totalTimeRequired = 0;
    } else {
      totalTimeRequired = newTargetAmount / contributionAmount;
    }

    let additionalMonths = Math.ceil(totalTimeRequired % 12);
    if (totalTimeRequired * contributionAmount < newTargetAmount) {
      additionalMonths = Math.floor(totalTimeRequired % 12);
    }

    let additionalYears =
      (Math.ceil(totalTimeRequired) - additionalMonths) / 12;

    if (currentMonth + additionalMonths > 12) {
      additionalYears = additionalYears + 1;
    }

    const goalWhenDate = new Date(this.props.goalwhen);

    let newMonth =
      goalWhenDate.getFullYear() === currentYear &&
      goalWhenDate.getMonth() === currentMonth &&
      totalTimeRequired === 1
        ? currentMonth
        : currentMonth + additionalMonths;

    if (newMonth >= 11) {
      newMonth = newMonth - 13;
      if (newMonth < 0) {
        if (newMonth === -1) {
          newMonth = 11;
        } else if (newMonth === -2) {
          newMonth = 10;
        }
      }
    }

    const expectedFullDate = new Date(this.props.goalwhen);
    const expectedMonth = expectedFullDate.getMonth();
    const expectedYear = expectedFullDate.getFullYear();

    expectedTimeSpan = Number(
      (expectedYear - currentYear) * 12 + (expectedMonth - currentMonth) + 1
    );
    if (expectedTimeSpan <= 0) {
      expectedTimeSpan = 1;
    }
    let expextedContribution = Math.abs(newTargetAmount / expectedTimeSpan);
    if (_.isInteger(expextedContribution)) {
      expextedContribution = expextedContribution.toFixed(2);
    } else {
      expextedContribution = Math.ceil(expextedContribution * 100) / 100;
      expextedContribution = expextedContribution.toFixed(2);
    }
    const newYear = Math.floor(currentYear + additionalYears);
    const newMonthYearString = `${newMonth} ${newYear}`;
    const expectedMonthYearString = `${expectedMonth} ${expectedYear}`;

    if (newMonthYearString === expectedMonthYearString) {
      differentiator = 'ON_TARGET_BUT_OVER';
    } else {
      differentiator = 'SMASH_IT';
    }

    return this.conditionCheck(
      currentYear,
      newYear,
      currentMonth,
      newMonth,
      newTargetAmount,
      contributionAmount,
      totalTimeRequired,
      expectedMonth,
      expectedYear,
      expextedContribution,
      differentiator,
      expectedTimeSpan
    );
  }

  render() {
    return <div>{this.contentHolder()}</div>;
  }
}

PotDetailMessages.propTypes = {
  amountvalue: PropTypes.number,
  goal: PropTypes.number,
  balance: PropTypes.number,
  goalwhen: PropTypes.string,
  content: PropTypes.object,
};

export { PotDetailMessages };
